import React from "react";
import { useQueryParam } from "use-query-params";

import { PageTabs } from "../../../components/ui/PageTabs";

import Dados from "../Dados";
import HorarioFuncionamento from "../HorarioFuncionamento";

const ABAS = [
  { value: "dados", label: "Dados" },
  { value: "horario", label: "Horário de funcionamento" },
];

export function Informacoes() {
  // guardamos a aba na URL para que recarregar a pagina (ou mandar o link
  // para outra pessoa) caia na mesma aba, como no CRM Pet.
  const [aba, setAba] = useQueryParam("info");
  const ativa = ABAS.some((item) => item.value === aba) ? aba : "dados";

  return (
    <div className="flex flex-col w-full">
      <PageTabs
        ariaLabel="Informações da loja"
        tabs={ABAS}
        value={ativa}
        onChange={setAba}
      />

      <div className="w-full pt-2">
        {ativa === "horario" ? <HorarioFuncionamento /> : <Dados />}
      </div>
    </div>
  );
}

export default Informacoes;
